export const productsData = {
  categories: [
    { id: "all", name: "All", filter: "*" },
    // { id: "diagnostic", name: "Diagnostic Tools", filter: ".diagnostic" },
    // { id: "treatment", name: "Treatment Devices", filter: ".treatment" },
    // { id: "wellness", name: "Wellness Products", filter: ".wellness" },
    // { id: "monitoring", name: "Monitoring Equipment", filter: ".monitoring" }
  ],
  products: [
    {
      id: 1,
      name: "Silodosin Tablets",
      description: "Helps ease urinary problems caused by an enlarged prostate by relaxing the prostate and bladder muscles, improving urine flow and overall comfort.",
      images: [
        "/assets/img/products/products/1.jpeg",
        "/assets/img/products/products/hover/Bnign 4 Black.jpeg",
        "/assets/img/products/products/hover/Bnign 8 White.jpeg"
      ],
      category: "urology",
      price: "$49",
      features: ["Relieves urinary symptoms", "Improves flow", "Enhances comfort"]
    },
    {
      id: 2,
      name: "Silodosin 8mg + Dutasteride 0.5mg Tablets",
      description: "Dual-action treatment that relieves frequent urination, weak flow, and gradually shrinks the prostate for long-term relief.",
      images: [
        "/assets/img/products/products/2.jpeg",
        "/assets/img/products/products/hover/Bnign plus 8 white.jpeg"
      ],
      category: "urology",
      price: "$79",
      features: ["Dual-action relief", "Reduces prostate size", "Long-term results"]
    },
    {
      id: 3,
      name: "Tamsulosin Hydrochloride 0.4mg Tablets",
      description: "Provides quick and effective relief from difficulty passing urine, weak stream, and urgency linked to prostate enlargement.",
      images: [
        "/assets/img/products/products/3.jpeg",
        "/assets/img/products/products/hover/Dyotam white.jpeg"
      ],
      category: "urology",
      price: "$39",
      features: ["Quick relief", "Improves urine flow", "Trusted therapy"]
    },
    {
      id: 4,
      name: "Tamsulosin 0.4mg + Dutasteride 0.5mg Tablets",
      description: "Combination therapy that eases urination immediately while also reducing prostate size over time for lasting control.",
      images: [
        "/assets/img/products/products/4.jpeg",
        "/assets/img/products/products/hover/Dyotam plus white.jpeg"
      ],
      category: "urology",
      price: "$69",
      features: ["Immediate relief", "Prostate shrinkage", "Long-term comfort"]
    },
    {
      id: 5,
      name: "Tadalafil 5mg + Alfuzosin 10mg Tablets",
      description: "Specially designed for men with urinary issues and erectile dysfunction, improving urine flow while restoring sexual performance.",
      images: [
        "/assets/img/products/products/5.jpeg",
        "/assets/img/products/products/hover/Tedalfa.jpeg"
      ],
      category: "men's health",
      price: "$99",
      features: ["Dual benefit", "Better urinary flow", "Improves intimacy"]
    },
    {
      id: 6,
      name: "Tadalafil Tablets 5mg/10mg/20mg",
      description: "Widely trusted tablets for erectile dysfunction that enhance erections and confidence. The 5mg dose also helps with urinary issues related to prostate enlargement.",
      images: [
        "/assets/img/products/products/6.jpeg",
        "/assets/img/products/products/hover/Edted 10 white.jpeg",
        "/assets/img/products/products/hover/Edted 20 white.jpeg"
      ],
      category: "men's health",
      price: "$89",
      features: ["Improves erections", "Restores confidence", "Supports prostate health"]
    },
    {
      id: 7,
      name: "Lidocaine 7.5mg + Prilocaine 2.5mg Spray",
      description: "Fast-acting spray that gently reduces sensitivity, helping delay ejaculation and extend intimacy for greater satisfaction.",
      images: [
        "/assets/img/products/products/7.jpeg",
        "/assets/img/products/products/hover/eds.jpeg"
      ],
      category: "sexual health",
      price: "$29",
      features: ["Delays ejaculation", "Enhances intimacy", "Easy to use"]
    },
    {
      id: 9,
      name: "Mirabegron Extended-Release Tablets 25mg & 50mg",
      description: "Helps control sudden urges, frequent urination, and leakage due to overactive bladder, allowing you to live more freely and confidently.",
      images: [
        "/assets/img/products/products/9.jpeg",
        "/assets/img/products/products/hover/Betmira 50 White.jpeg",
        "/assets/img/products/products/hover/Betmira 25.jpeg"
      ],
      category: "urology",
      price: "$79",
      features: ["Reduces urgency", "Controls leakage", "Improves bladder function"]
    },
    {
      id: 10,
      name: "Solifenacin Succinate 5mg Tablets",
      description: "Calms an overactive bladder, reducing frequent bathroom trips and accidental leakage for improved daily confidence.",
      images: [
        "/assets/img/products/products/10.jpeg",
        "/assets/img/products/products/hover/VesiQ.jpeg"
      ],
      category: "urology",
      price: "$59",
      features: ["Better bladder control", "Fewer trips", "Reduces leakage"]
    },
    {
      id: 11,
      name: "Cefixime 200mg + Ofloxacin 200mg Tablets",
      description: "A strong antibiotic combination that treats infections of the lungs, urinary tract, and stomach, helping you recover quickly and effectively.",
      images: [
        "/assets/img/products/products/11.jpeg",
         "/assets/img/products/products/hover/Demxim.jpeg"
      ],
      category: "antibiotic",
      price: "$69",
      features: ["Fights tough infections", "Broad-spectrum action", "Fast recovery"]
    },
    {
      id: 12,
      name: "Faropenem Tablets",
      description: "An advanced antibiotic that works against resistant infections, providing strong protection and ensuring reliable recovery.",
      images: [
        "/assets/img/products/products/12.jpeg",
        "/assets/img/products/products/hover/Dfaro 200 White.jpeg",
        "/assets/img/products/products/hover/Dfaro ER 300.jpeg"
      ],
      category: "antibiotic",
      price: "$89",
      features: ["Powerful antibiotic", "Fights resistance", "Reliable treatment"]
    },
    {
      id: 8,
      name: "Lignocaine Hydrochloride 2% Gel",
      description: "A soothing anesthetic jelly for pain relief in urological or gynecological use, offering comfort during minor medical procedures.",
      images: [
        "/assets/img/products/products/13.png"
      ],
      category: "anesthetic",
      price: "$19",
      features: ["Pain relief", "Soothing effect", "Safe application"]
    }
  ]
};
